import { render, staticRenderFns } from "./UserBalance.vue?vue&type=template&id=fd88e742&"
import script from "./UserBalance.vue?vue&type=script&lang=js&"
export * from "./UserBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports